exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-tag {\n  position: relative;\n  color: #fff;\n}\n.product-card__reservation-type {\n  background: #52c41a;\n  color: #fff;\n  text-align: center;\n}\n.product-tag-addional-info {\n  padding: 0 0 0 8px;\n}\n.product-tag.product-tag__addional-info {\n  padding: 4px 8px;\n}\n.product-tag.product-tag--full {\n  background-color: #ffda2e;\n  background-image: -webkit-gradient(linear, left top, right top, from(#ff8d47), to(#ffda2e));\n  background-image: linear-gradient(to right, #ff8d47, #ffda2e);\n}\n.product-tag.product-tag--complete {\n  background: #f7931e;\n  padding: 4px 8px;\n}\n", ""]);

// exports
